import dynamic from 'next/dynamic';
import { ComponentProps } from 'react';

const FilterModal = dynamic(() => import('./filter-modal'), { ssr: false });

let isLoaded = false;

const FilterModalLazyLoad = (props: ComponentProps<typeof FilterModal>) => {
  const { open } = props;

  if (open) {
    isLoaded = true;
  }

  return isLoaded && <FilterModal {...props} />;
};

export default FilterModalLazyLoad;
